import type { SupplierOnboardingStepId } from "~/pages/SupplierPortal/Onboarding/constants/supplierOnboardingSteps"
import { SUPPLIER_ONBOARDING_STEP_IDS } from "~/pages/SupplierPortal/Onboarding/constants/supplierOnboardingSteps"
import {
  BLOCKED_ONBOARDING_REDIRECT_PATH,
  SUPPLIER_ONBOARDING_ENTRY_PATH,
} from "~/pages/SupplierPortal/Onboarding/constants/onboardingGate.constants"

import type { OnboardingEntryDecision } from "./onboardingEntryDecision"

export type AuthenticatedNavigationTarget = Readonly<{
  path: string
  initialStepId?: SupplierOnboardingStepId
  shouldLogout: boolean
}>

export const buildAuthenticatedNavigationTarget = ({
  decision,
  homeRedirectUrl,
}: {
  decision: OnboardingEntryDecision
  homeRedirectUrl: string
}): AuthenticatedNavigationTarget => {
  switch (decision.outcome) {
    case "skip":
      return { path: homeRedirectUrl, shouldLogout: false }
    case "start":
      return {
        path: SUPPLIER_ONBOARDING_ENTRY_PATH,
        initialStepId: SUPPLIER_ONBOARDING_STEP_IDS.welcome,
        shouldLogout: false,
      }
    case "resume":
      return {
        path: SUPPLIER_ONBOARDING_ENTRY_PATH,
        initialStepId: decision.stepId ?? SUPPLIER_ONBOARDING_STEP_IDS.welcome,
        shouldLogout: false,
      }
    case "block":
      return {
        path: BLOCKED_ONBOARDING_REDIRECT_PATH,
        shouldLogout: true,
      }
  }
}
